module.exports = __webpack_public_path__ + "img/close-border-red.75b7d67c.svg";